import React, { useState } from 'react';
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { useGeneral } from '../../Context/GeneralContext';
import { useEffect } from 'react';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

// const useStyles = makeStyles({
//     root: {
//         width: '100%',
//         display: 'flex',
//         justifyContent: 'end',
//     },
// });

export default function SimpleTabs() {
    const [value, setValue] = useState(0);
    const { intervalo, setIntervalo, setIsLoadingTable, setParos } = useGeneral();

    const handleChange = (event, newValue) => {
        setParos([]);
        setIsLoadingTable(true);
        setValue(newValue);
        if (newValue === 0) {
            setIntervalo(0);
        } else if (newValue === 1) {
            setIntervalo(4);
        } else if (newValue === 2) {
            setIntervalo(8);
        } else {
            setIntervalo(12);
        }
    };

    useEffect(() => {
        if (intervalo === 0) {
            setValue(0);
        } else if (intervalo === 4) {
            setValue(1);
        } else if (intervalo === 8) {
            setValue(2);
        } else {
            setValue(3);
        }
    }, [intervalo]);

    useEffect(() => {
        if (intervalo === 0) {
            setValue(0);
        } else if (intervalo === 4) {
            setValue(1);
        } else if (intervalo === 8) {
            setValue(2);
        } else {
            setValue(3);
        }
    }, [intervalo]);

    return (
        <div className="static paros-tabindi-wrapper">
            <AppBar position="static">
                <Tabs value={value} onChange={handleChange} scrollButtons={false}>
                    <Tab label="Corrida" />
                    <Tab label="4 Horas" />
                    <Tab label="8 Horas" />
                    <Tab label="12 Horas" />
                </Tabs>
            </AppBar>
        </div>
    );
}
